import { Box, Grid2, Skeleton, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";

// FAQ skeleton
export const FAQSectionSkeleton = () => {
  return (
    <>
      <Stack gap={2} width={"100%"} padding={"20px"}>
        <Skeleton variant="rounded" animation="wave" height={"50px"} />
        <Skeleton variant="rounded" animation="wave" height={"50px"} />
        <Skeleton variant="rounded" animation="wave" height={"50px"} />
      </Stack>
    </>
  );
};

// Counter stats skeleton
export const FreedoCounterSkeleton = () => {
  return (
    <>
      <Grid size={{ sm: 12, md: 6 }}>
        <Stack gap={"1rem"} width={"100%"} alignItems={"center"}>
          <Grid size={{ sm: 12, md: 6 }} width={"100%"}>
            <Stack
              gap={"1rem"}
              direction="row"
              width={"100%"}
              justifyContent={"center"}
            >
              <Skeleton
                variant="rounded"
                animation="wave"
                height={"80px"}
                width={"150px"}
              />
              <Skeleton
                variant="rounded"
                animation="wave"
                height={"80px"}
                width={"150px"}
              />
            </Stack>
          </Grid>
          <Grid size={{ sm: 12, md: 6 }} width={"100%"}>
            <Stack
              gap={"1rem"}
              direction="row"
              width={"100%"}
              justifyContent={"center"}
            >
              <Skeleton
                variant="rounded"
                animation="wave"
                height={"80px"}
                width={"150px"}
              />
              <Skeleton
                variant="rounded"
                animation="wave"
                height={"80px"}
                width={"150px"}
              />
            </Stack>
          </Grid>
        </Stack>
      </Grid>
      <Grid size={{ sm: 12, md: 6 }}>
        <Skeleton variant="rectangular" animation="wave" height={"300px"} />
      </Grid>
    </>
  );
};

// When Pictures Speaks Skeleton
export const PictureSpeakSkeleton = () => {
  return (
    <>
      <Grid2 size={{ sm: 12, md: 6, lg: 4 }} key={`picture-skeleton1`}>
        <Box key={`skeletonItem1`}>
          <Box className="card testimonial" gap={"1rem"}>
            <Box className="testimonial-img-container">
              <Skeleton
                variant="rounded"
                animation="wave"
                height={"90%"}
                width={"100%"}
              />
            </Box>
            <Stack padding={"1rem"} gap="5px">
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
            </Stack>
          </Box>
        </Box>
      </Grid2>
      <Grid2 size={{ sm: 12, md: 6, lg: 4 }} key={`picture-skeleton2`}>
        <Box key={`skeletonItem2`}>
          <Box className="card testimonial" gap={"1rem"}>
            <Box className="testimonial-img-container">
              <Skeleton
                variant="rounded"
                animation="wave"
                height={"90%"}
                width={"100%"}
              />
            </Box>
            <Stack padding={"1rem"} gap="5px">
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
            </Stack>
          </Box>
        </Box>
      </Grid2>
      <Grid2 size={{ sm: 12, md: 6, lg: 4 }} key={`picture-skeleton3`}>
        <Box key={`skeletonItem3`}>
          <Box className="card testimonial" gap={"1rem"}>
            <Box className="testimonial-img-container">
              <Skeleton
                variant="rounded"
                animation="wave"
                height={"90%"}
                width={"100%"}
              />
            </Box>
            <Stack padding={"1rem"} gap="5px">
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
              <Skeleton animation="wave" height={"20px"} width={"100%"} />
            </Stack>
          </Box>
        </Box>
      </Grid2>
    </>
  );
};

// Freedo feature skeleton
export const FreedoFeatureSkeleton = () => {
  return (
    <>
      <Skeleton
        variant="rounded"
        animation="wave"
        height={"50px"}
        width={"20%"}
      />
      <Skeleton
        variant="rounded"
        animation="wave"
        height={"50px"}
        width={"20%"}
      />
      <Skeleton
        variant="rounded"
        animation="wave"
        height={"50px"}
        width={"20%"}
      />
      <Skeleton
        variant="rounded"
        animation="wave"
        height={"50px"}
        width={"20%"}
      />
      <Skeleton
        variant="rounded"
        animation="wave"
        height={"50px"}
        width={"20%"}
      />
    </>
  );
};
